import { BankPaymentSummaryEntity } from "../entities/BankPaymentSummaryEntity";
import { BankPaymentsRepository } from "../repositories/BankPaymentsRepository";

export class GetBankPaymentsSummaryUseCase {
  constructor(private repository: BankPaymentsRepository) {}

  async execute(): Promise<BankPaymentSummaryEntity> {
    return await this.repository.getPendingPaymentsSummary();
  }
}

